import type { KeywordsMatch } from '@frameio/graphql-client/generated';
import type { AssetResultMatch } from '../types';

export const mergeKeywordMatches = (
  matches: AssetResultMatch[] = []
): AssetResultMatch[] => {
  const keywordMatches = matches.filter(
    (match) => match.__typename === 'KeywordsMatch'
  ) as KeywordsMatch[];
  const otherMatches = matches.filter(
    (match) => match.__typename !== 'KeywordsMatch'
  );
  const combinedKeywords = keywordMatches.reduce(
    (acc, match) => {
      return [...(acc ?? []), ...(match.keywords ?? [])];
    },
    [] as KeywordsMatch['keywords']
  );
  if (combinedKeywords?.length === 0) {
    return otherMatches;
  }
  return [
    ...otherMatches,
    { __typename: 'KeywordsMatch', keywords: combinedKeywords },
  ];
};
